<template>
  <div class="h-screen">
    <div class="flex items-center justify-center w-full h-full">
      <div class="h-auto pb-2 w-96">
        <div class="h-auto">
          <div class="h-full">
            <div class="px-3 m-0">
              <div class="card-style">
                <slot />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
